import React, { useEffect, useState } from "react";
import steam from "../../assets/steam512.png";
import discord from "../../assets/discord512.png";
import mumble from "../../assets/mumble512.png";
import teamspeak from "../../assets/ts512.png";
import { getLinks } from "../../api/event.api";
import { Link, Typography, Grid } from "@mui/material";

const Links = () => {
  const [links, setLinks] = useState({});
  useEffect(() => {
    getLinks()
      .then((response) => setLinks(response.data))
      .catch((e) => console.log(e));
  }, []);

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        Links
      </Typography>
      <Grid container spacing={1}>
        <Grid xs={12} sm={6} md={4}>
          <Link href={links.discordUrl} rel="noreferrer">
            <img
              width="30px"
              height="auto"
              src={discord}
              alt="logo"
              loading="lazy"
            />
          </Link>
        </Grid>
        <Grid xs={12} sm={6} md={4}>
          <Link href={links.steamUrl} rel="noreferrer">
            <img
              width="30px"
              height="auto"
              src={steam}
              alt="logo"
              loading="lazy"
            />
          </Link>
        </Grid>
        {links.mumbleUrl && (
          <Grid xs={12} sm={6} md={4}>
            <Link href={links.mumbleUrl} rel="noreferrer">
              <img
                width="30px"
                height="auto"
                src={mumble}
                alt="logo"
                loading="lazy"
              />
            </Link>
          </Grid>
        )}
        {links.teamspeakUrl && (
          <Grid xs={12} sm={6} md={4}>
            <Link href={links.teamspeakUrl} rel="noreferrer">
              <img
                width="30px"
                height="auto"
                src={teamspeak}
                alt="logo"
                loading="lazy"
              />
            </Link>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default Links;
